import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from 'src/services/api.service';
import { Subject } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { goToLoginIfNotLoggedIn } from 'src/services/ObservableExtension';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { stringify } from '@angular/compiler/src/util';

interface Days {
  value: string;
  text: string;
}

@Component({
  selector: 'app-alarm-settings',
  templateUrl: './alarm-settings.component.html',
  styleUrls: ['./alarm-settings.component.scss']
})

export class AlarmSettingsComponent implements OnInit, OnDestroy {

  unsubscribe$ = new Subject<any>();

  customer: any = {};

  sensor: any = {};

  ventProtectionTime: any = {};

  isSubmitted: boolean = false;

  maximumFlowAlarm: any = {};

  alarms: any = {};
  valveSettingErrorMessage: any = "";

  form: FormGroup;

  isValveOpen: boolean;

  message: string = "";

  isLeakageAlarmInActive: boolean = false;

  days: Days[] = [
    { value: '', text: 'Keine' },
    { value: '1', text: 'Montag' },
    { value: '2', text: 'Dienstag' },
    { value: '3', text: 'Mittwoch' },
    { value: '4', text: 'Donnerstag' },
    { value: '5', text: 'Freitag' },
    { value: '6', text: 'Samstag' },
    { value: '7', text: 'Sonntag' },
  ];

  constructor(
    public api: ApiService,
    private router: Router,
    private messageService: MessageService
  ) {
    api.pageTitle = 'Einstellungen';
  }

  ngOnInit() {
    this.alarms = {
      LeakageAlarm: {
        IsActive: false
      },
      PipeBreakAlarm: {
        Content: ""
      },
      MaximumFlowAlarm: {
        Content: ""
      },
      PermanentFlowAlarm: {
        Content: ""
      }
    }

    this.api.get('customerData')
      .pipe(goToLoginIfNotLoggedIn(this.router))
      .subscribe((res: any) => {
        this.customer = res.Customer;
        this.sensor = res.Sensor;

        this.ventProtectionTime = JSON.parse(this.sensor.VentProtectionTime);

      });

    this.getAlarms();

    this.valveSettingErrorMessage = "";
  }

  getAlarms() {
    this.api.get('customeralarms').subscribe(c => {
      this.alarms = c;

      //this means leakage alarm is off and PressureMeasurementDay is none
      if (!this.alarms.LeakageAlarm.IsActive) {
        this.isLeakageAlarmInActive = true;

        if (this.alarms.PressureMeasurementDay == 'FF') {
          this.alarms.PressureMeasurementDay = this.days[0].text;
        }
      }      
    });
  }

  save(customer) {
    this.isSubmitted = true;

    this.sensor.ventProtectionTime = JSON.stringify(this.ventProtectionTime);

    this.api.put('customeralarms/', this.alarms)
      .subscribe((response: any) => {
      }, (error: any) => { })
      .add(() => {
        this.api.put('customer/', { Customer: this.customer, Sensor: this.sensor })
          .subscribe((res: any) => {
            this.valveSettingErrorMessage = res.Message;
            this.messageService.add({ severity: 'success', summary: 'Einstellungen erfolgreich gespeichert', closable: true, life: 3000 });
            this.isSubmitted = false;
          }, (error: any) => {
            this.messageService.add({ severity: 'error', summary: 'Einstellungen konnten nicht gespeichert werden', closable: true, life: 3000 });
            this.isSubmitted = false;
          });
      });
  }

  leakageAlarmValueChange(event: any) {
    let updatedLeakageValue = event || false;
    if (!updatedLeakageValue) {
      let updatedTime = { hour: 0, minute: 0 };
      this.isLeakageAlarmInActive = true;
      this.alarms.PressureMeasurementDay = this.days[0].text;
      this.alarms.PressureMeasurementTime = updatedTime;
      this.alarms.PermanentFlowAlarm.Content = "0";
      this.alarms.MaximumFlowAlarm.Content = "0";
    } else {
      this.isLeakageAlarmInActive = false;
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
  }
}




